import {AnnotationShapeIDMap} from "../Audit/AuditConstants";

export const DEFAULT_MAX_VIDEO_DURATION = 30;

export const SubscriberTierID = {
    ELITE: 1,
    PROFESSIONAL: 2,
    ESSENTIAL: 3,
};

export const SubscriberTierLimits = {
    [SubscriberTierID.ELITE]: {
        "max_images_count_per_annotation": null,
        "max_videos_count_per_annotation": null,
        "max_video_duration": null,
        "max_audits_count_per_user": null,
        "audit_annotations_ids": [
            AnnotationShapeIDMap.PIN.id,
            AnnotationShapeIDMap.LINE.id,
            AnnotationShapeIDMap.AREA.id,
        ],
        "can_clone_audits": true,
        "can_assign_audit": true,
        "can_brand_audit": true,
    },
    [SubscriberTierID.PROFESSIONAL]: {
        "max_images_count_per_annotation": 4,
        "max_videos_count_per_annotation": 1,
        "max_video_duration": 15,
        "max_audits_count_per_user": 48,
        "audit_annotations_ids": [AnnotationShapeIDMap.PIN.id, AnnotationShapeIDMap.LINE.id],
        "can_clone_audits": true,
        "can_assign_audit": true,
        "can_brand_audit": true,
    },
    [SubscriberTierID.ESSENTIAL]: {
        "max_images_count_per_annotation": 2,
        "max_videos_count_per_annotation": 0,
        "max_video_duration": 0,
        "max_audits_count_per_user": 24,
        "audit_annotations_ids": [AnnotationShapeIDMap.PIN.id],
        "can_clone_audits": false,
        "can_assign_audit": false,
        "can_brand_audit": false,
    },
};
